<template>
    <div id="layout-header">
        <div class="site-logo">
            <router-link to="/">
                <img :src="this.$store.state.webConfig.logo" alt="logo">
                <span class="site-name">{{ this.$store.state.webConfig.name }}</span>
            </router-link>
        </div>
        <div class="site-menus">
            <div class="menu-item header-search">
                <header-search></header-search>
            </div>
            <div class="menu-item">
                <router-link to="/"><i class="iconfont icon-zhuye"/>首页</router-link>
            </div>
            <div class="menu-item hasChild">
                <router-link to="/category"><i class="iconfont icon-16"/>文章</router-link>
                <div class="childMenu" v-if="categoryList.length">
                    <div class="sub-menu" v-for="item in categoryList" :key="item.id">
                        <router-link :to="`/category/${item.id}`">{{ item.name }}({{ item.articleNum }})</router-link>
                    </div>
                </div>
            </div>
            <div class="menu-item">
                <router-link to="/source"><i class="iconfont icon-HTMLyuanma"/>源码</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/tool"><i class="iconfont icon-gongju"/>工具</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/tag"><i class="iconfont icon-24gf-tags2"/>标签</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/timeAxis"><i class="iconfont icon-shijian"/>时间轴</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/friendChain"><i class="iconfont icon-lianjie"/>友链</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/about"><i class="iconfont icon-guanyu"/>关于</router-link>
            </div>
        </div>
        <div class="menu-user">
            <header-user></header-user>
        </div>
    </div>
</template>

<script>
    import {listCategory} from "@/api";
    import HeaderSearch from "@/components/header/header-search";
    import HeaderUser from "@/components/header/header-user";

    export default {
        name: "layout-header",
        components: {HeaderUser, HeaderSearch},
        data() {
            return {
                categoryList: []
            }
        },
        mounted() {
            this.getWebSiteInfo();
            this.listCategory();
        },
        methods: {
            // 查询网站信息
            getWebSiteInfo() {
                this.$store.dispatch('setWebInfo');
            },
            // 查询分类
            listCategory() {
                listCategory().then(res => {
                    this.categoryList = res.data
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>
<style scoped lang="less">
    #layout-header {
        position: fixed;
        top: 0;
        z-index: 2000;
        width: 100%;
        height: 64px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: box-shadow 0.3s ease, background 0.3s ease;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        border-bottom: 1px solid rgba(79, 110, 247, 0.08);
        box-shadow: 0 2px 12px rgba(79, 110, 247, 0.06);
    }

    a {
        text-decoration: none;
        color: #2c3e50;
    }

    .site-logo {
        padding-left: 48px;
        display: flex;
        align-items: center;
    }

    .site-logo a {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .site-logo img {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        object-fit: cover;
    }

    .site-name {
        font-size: 17px;
        font-weight: 700;
        background: linear-gradient(135deg, #4f6ef7 0%, #7b95fa 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: 0.5px;
    }

    .site-menus {
        display: flex;
        align-items: center;
        gap: 2px;
        margin: auto;
    }

    .menu-item {
        height: 64px;
        line-height: 64px;
        text-align: center;
        position: relative;
    }

    .menu-item a {
        display: inline-block;
        padding: 0 14px;
        font-weight: 500;
        font-size: 14.5px;
        color: #374151;
        border-radius: 6px;
        transition: all 0.2s ease;
        line-height: 36px;
        height: 36px;
    }

    .menu-item a:hover,
    .menu-item a.route-active {
        color: #4f6ef7;
        background: rgba(79, 110, 247, 0.08);
    }

    .menu-item a i {
        margin-right: 4px;
        font-size: 13px;
    }

    .hasChild:hover .childMenu {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }

    .childMenu {
        min-width: 150px;
        background-color: #fff;
        border-radius: 10px;
        border: 1px solid rgba(79, 110, 247, 0.12);
        box-shadow: 0 8px 24px rgba(79, 110, 247, 0.15);
        position: absolute;
        top: 60px;
        left: 50%;
        transform: translateX(-50%) translateY(-8px);
        z-index: 10;
        opacity: 0;
        visibility: hidden;
        transition: all 0.25s ease;
        padding: 6px;
    }

    .childMenu:before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 7px solid rgba(79, 110, 247, 0.12);
        top: -8px;
        left: 50%;
        transform: translateX(-50%);
    }

    .childMenu:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 7px solid #fff;
        top: -7px;
        left: 50%;
        transform: translateX(-50%);
    }

    .sub-menu {
        height: 38px;
        line-height: 38px;
        border-radius: 6px;
        transition: background 0.2s;
    }

    .sub-menu a {
        display: block;
        padding: 0 12px;
        font-size: 13px;
        color: #374151;
        height: 38px;
        line-height: 38px;
        border-radius: 6px;
        white-space: nowrap;
    }

    .sub-menu a:hover {
        background: rgba(79, 110, 247, 0.08);
        color: #4f6ef7;
    }

    .menu-user {
        padding-right: 48px;
    }

    .header-search {
        margin-right: 4px;
    }
</style>
